import { useSendCommand } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { MoveStatus as MoveStatusCommand } from '@/pages/main/storymap/api/commands';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class MoveStatus extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'MoveStatus';

    public constructor(public key: number, public order: number) {
        super(MoveStatus.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: MoveStatus): Promise<boolean> => {
    useSendCommand(action, {
        createCommand: () => new MoveStatusCommand(state.id, action.key, action.order),
    });

    return true;
};

const reducer = (state: StorymapState, action: MoveStatus): void => {
    const status = state.subtaskStatuses.find((x) => x.key === action.key);

    const statusesToReorder = state.subtaskStatuses.filter((x) => x.order > status.order);
    statusesToReorder.forEach((x) => x.order--);

    const statusesToReorderInc = state.subtaskStatuses.filter((x) => x.order >= action.order);
    statusesToReorderInc.forEach((x) => x.order++);

    status.order = action.order;
};

//@ts-ignore
registerMiddleware(MoveStatus.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(MoveStatus.ACTION_TYPE, reducer);
